//
// ConnectionManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "../models/media/particles/LogonStatus";
import "../models/media/particles/EsriLogonStatus";
import "../models/media/particles/EsriPortalLogonStatus";
import "./Voucher";
import "./WebLogonAvailability";
import "@sas-dvr/ltjs-commons/maps/MapConnectionInfo";
import "../models/media/particles/EsriPortalAuthenticationConfigurationType";
import "../models/media/particles/CatalogSearchSuggestions";

var ConnectionManager = createModule("transport::ConnectionManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        clearSessionToken: [0],
        logon: [1],
        requestEsriPremiumToken: [0],
        getEsriLogonStatus: [4],
        getLogonStatus: [4],
        supportsWebLogonFlow: [4],
        setEsriPortalCredentials: [1,7,7],
        getEsriCredentials: [1],
        requestEsriAllTokens: [1],
        getEsriPortalAuthenticationSSOLoginURL: [7],
        shouldUsePkceForOauth2: [2],
        setEsriCredentials: [1,7,7],
        getAuthorizationHeaders: [[7]],
        getEsriPortalLogonStatus: [4],
        checkDevice: [1],
        initializeSession: [1,7],
        getStoredPassword: [7],
        generateCodeVerifier: [7],
        getServerConfig: [1],
        filteredCatalogSearchSuggestionsForFacetType: [1,4,7],
        keepAlive: [1],
        getLogo: [1],
        getEsriPortalCredentials: [1],
        requestEsriPortalToken: [0],
        isPersonalizationEnabled: [2],
        getEsriPortalAuthenticationConfiguration: [4],
        hasCapability: [2,4],
        downloadFile: [1,7,7],
        getMapConnectionInfo: [1],
        logoff: [1],
        _log_o: [1,[7]],
        catalogSearchSuggestionsForFacetType: [1,4],
        getCookieHeaders: [[7]],
        migrateToWebLogonForViya35: [0],
        _log_s: [1,7],
        filteredCatalogSearchSuggestionsForAllFacetTypes: [[1],7],
        getUserAvatar: [1,7],
    },
    ,
    ["log"],
]);
export default ConnectionManager;
